<div id="m" class="page-layout-container">
  <div id="mobility" class="page-container">
    <div class="header-section">
      <div class="header-copy">
        <h1 class="title">Manage Employees Mobility Budget</h1>
        <p class="subtitle">
          Update mobility opt-in status, effective date, and budget in one
          place.
        </p>
      </div>
    </div>

    <div class="message-container">
      <div *ngIf="message" class="alert alert-success">{{ messageDesc }}</div>
      <div *ngIf="error" class="alert alert-danger">{{ errorDesc }}</div>
      <div *ngIf="warningDesc" class="alert alert-warning">
        {{ warningDesc }}
      </div>
    </div>

    <div class="form-section">
      <div class="row form-row">
        <div class="col-6 employee-select">
          <app-emp-name
            [filterEmpName]="filterEmpName"
            (empName)="empNameSelected($event)"
          ></app-emp-name>
        </div>
        <div class="col month-select">
          <mat-form-field appearance="fill">
            <input
              matInput
              [matDatepicker]="dp"
              placeholder="Select Year"
              [formControl]="yearSelected"
            />
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker
              #dp
              startView="multi-year"
              (yearSelected)="chosenYearHandler($event, dp)"
              panelClass="example-month-picker"
            ></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <form [formGroup]="mobilityForm" class="form-section form-card">
      <div class="row form-row">
        <div class="col-4">
          <div class="checkbox-group">
            <mat-checkbox
              formControlName="isMobilityOpted"
              (change)="enableMobilitySection($event.checked)"
            >
              Mobility Opted *
            </mat-checkbox>
          </div>
        </div>
        <div class="col-6">
          <mat-form-field appearance="fill" class="form-col">
            <mat-label>Comments *</mat-label>
            <textarea matInput formControlName="comments" required></textarea>
            <mat-error
              *ngIf="mobilityForm.get('comments')?.hasError('required')"
            >
              Comments are required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row form-row" *ngIf="mobilitySecFlag">
        <div class="col">
          <mat-form-field appearance="fill">
            <mat-label>Mobility Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="mobilityStartDate"
              [matDatepickerFilter]="dateFilter"
              formControlName="mobilityEffectiveDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="mobilityStartDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #mobilityStartDate></mat-datepicker>
            <mat-error
              *ngIf="
                mobilitySecFlag &&
                mobilityForm.get('mobilityEffectiveDate')?.hasError('required')
              "
            >
              Mobility start date is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="fill">
            <mat-label>Applicable Mobility Budget</mat-label>
            <input
              matInput
              placeholder="In Euros"
              formControlName="applicableBudget"
            />
            <mat-error
              *ngIf="
                mobilitySecFlag &&
                mobilityForm.get('applicableBudget')?.hasError('required')
              "
            >
              Budget is required when mobility is opted.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>

    <div class="submit-button-container">
      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="mobilityForm.invalid || !empName || !yearSelected.value"
        type="button"
      >
        Submit
      </button>
    </div>
  </div>
</div>
